// extracted by mini-css-extract-plugin
module.exports = {"container":"results_container__fzXI0","result":"results_result__mFrME","title":"results_title__oMRpi","subtitle":"results_subtitle__hHpDS"};